import { render, staticRenderFns } from "./ship-tab-view.vue?vue&type=template&id=6ac80575&scoped=true&"
import script from "./ship-tab-view.vue?vue&type=script&lang=js&"
export * from "./ship-tab-view.vue?vue&type=script&lang=js&"
import style0 from "./ship-tab-view.vue?vue&type=style&index=0&id=6ac80575&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac80575",
  null
  
)

export default component.exports